import { Controller } from "@hotwired/stimulus"

// Accept / reject / regenerate a user's OWN held presenter generation
// (Presenter Step Redesign — generate review gate). Each card carries the action
// URL on the button; on success the card is replaced with a short message
// (accepted clips become selectable on the next page load).
export default class extends Controller {
  accept(event) {
    return this.act(event, "POST", "Accepted — reload the page to select it.")
  }

  reject(event) {
    return this.act(event, "DELETE", "Removed.")
  }

  regenerate(event) {
    return this.act(event, "POST", "Regenerating — the new take appears here in a few minutes.")
  }

  async act(event, method, successMessage) {
    const button = event.currentTarget
    const url = button.dataset.url
    const card = button.closest(".presenter-review-card")
    if (!url || !card) return

    const buttons = card.querySelectorAll("button")
    buttons.forEach((b) => { b.disabled = true })

    try {
      const response = await fetch(url, {
        method,
        headers: { "X-CSRF-Token": this.csrfToken(), Accept: "application/json" }
      })
      if (response.ok) {
        card.textContent = successMessage
        return
      }
      const data = await response.json().catch(() => ({}))
      this.setStatus(card, data.error || "Action failed.")
    } catch (error) {
      this.setStatus(card, "Action failed.")
    }
    buttons.forEach((b) => { b.disabled = false })
  }

  setStatus(card, text) {
    const status = card.querySelector("[data-status]")
    if (status) status.textContent = text
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
